/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Bc_MismatchesInputs */

const en_queue_bc_mismatches = /** @type {(inputs: Queue_Bc_MismatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mismatches with Business Central`)
};

/**
* | output |
* | --- |
* | "Mismatches with Business Central" |
*
* @param {Queue_Bc_MismatchesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_bc_mismatches = /** @type {((inputs?: Queue_Bc_MismatchesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Bc_MismatchesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_bc_mismatches(inputs)
});